const News = [
      {
            "news":"FACTS-H LAB & Mozilla Present a 5-Day Bootcamp on Responsible Computing at IIIT Kottayam – March 17-21, 2025. (---Link---)",
            "link":"https://raw.githubusercontent.com/AlMIGHTY-HARDIK/test-repo/refs/heads/main/WhatsApp%20Image%202025-03-14%20at%2012.50.58_f4fc1737.jpg",
            "description":"-"
       },
      {
            "news":"Congratulations Dr. Jeena Thomas for receiving  the KUSUM DEEP BEST PhD THESIS AWARD 2025 given by  Indian Institute of Technology Roorkee.",
            "description":"-"
      },
      {
            "news":"FACTS-H Lab at IIIT Kottayam, in collaboration with the Centre for Memory Studies at IIT Madras, conducted a workshop to help educators and researchers use AI ethically and confidently. (---Link---)",
            "link":"https://www.thehindu.com/news/national/tamil-nadu/workshop-on-ai-to-bridge-gap-between-technology-and-humanities/article68918997.ece",
            "description":"-"
       },
       {
            "news":"FACTS-H Lab recently hosted the third and final General Partner Meeting of the AI FORA project, bringing together AI experts from 11 countries to discuss advancements in AI and its applications in public policy. (---Link---)",
            "link":"https://www.onmanorama.com/career-and-campus/top-news/2025/01/11/iiit-kottayam-hosts-key-ai-fora-meeting.html",
            "description":"-"
       },
       
      
  ];
  export default News